<template>
    <div class="flex gap-3 w-full">
        <button
            v-if="!isFirstStep"
            type="button"
            class="flex-1 py-3 rounded-full font-medium border border-theme-border text-theme-base hover:bg-theme-hover transition"
            @click="$emit('back')"
        >
            Atrás
        </button>
        <button
            type="button"
            :disabled="nextIsDisabled"
            class="flex-1 py-3 rounded-full font-medium transition"
            :class="nextButtonClasses"
            @click="$emit('next')"
        >
            {{ computedNextLabel }}
        </button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "OnboardingStepper",

    props: {
        currentStep: {
            type: String,
            required: true
        },
        locked: {
            type: Boolean,
            default: false
        },
        nextDisabled: {
            type: Boolean,
            default: false
        },
        nextLabel: {
            type: String,
            default: ""
        },
        nextVariant: {
            type: String,
            default: "primary"
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters("onboarding", ["orderedSteps"]),
        nextIsDisabled() {
            if (this.locked) return false;
            return this.nextDisabled || this.loading;
        },
        isFirstStep() {
            return this.orderedSteps[0] === this.currentStep;
        },
        computedNextLabel() {
            if (this.loading) return "Guardando...";
            if (this.nextLabel) return this.nextLabel;
            return this.locked ? "Ver siguiente paso" : "Continuar";
        },
        nextButtonClasses() {
            if (this.nextIsDisabled) {
                return "bg-theme-hover text-theme-disabled cursor-not-allowed";
            }
            if (this.nextVariant === "ghost") {
                return "border border-theme-border text-theme-base hover:bg-theme-hover";
            }
            return "bg-theme-primary text-white hover:opacity-90";
        }
    }
};
</script>
